<script lang="ts">
  import CheckCircleFulfilled from '../icons/CheckCircleFulfilled.svelte';

  export let name: string;
  export let label: string;
  export let icon: any;
  export let value: any;
  export let group: string;
</script>

<label for={value} class:selected={group === value}>
  <div>
    <input id={value} type="radio" {name} {value} bind:group />
    <svelte:component this={icon} />
    <span class="label">
      {@html label}
    </span>
  </div>
  <span class="checkmark">
    <span class="checked">
      <CheckCircleFulfilled />
    </span>
  </span>
</label>

<style lang="scss">
  label {
    border: 1px solid var(--twism-theme-slightBorder);
    border-radius: 8px;
    padding: 22px 14px;
    font-size: 13px;
    line-height: 16px;
    font-weight: 600;
    color: $color-firefly;
    margin: 5px 0;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;

    div {
      display: flex;
      align-items: center;
    }

    .label {
      max-width: 226px;
      text-overflow: ellipsis;
      overflow: hidden;
      margin-left: 12px;
    }

    input {
      display: none;
    }
    .checkmark {
      width: 20px;
      height: 20px;
      border-radius: 50%;
      background-color: $color-white;
      border: 1px solid var(--twism-theme-slightBorder);
      display: flex;
      align-items: center;
      justify-content: center;

      .checked {
        width: 20px;
        height: 20px;
        opacity: 0;
        transition: opacity 0.2s ease-in-out;
      }
    }
    &.selected {
      border-color: var(--twism-theme-primary);
      background: var(--twism-theme-slightBackground);
      color: var(--twism-theme-secondary);

      .checkmark {
        border-color: var(--twism-theme-illustration-secondary);
      }
      .checked {
        opacity: 1;
      }
    }
  }
</style>
